import { DragOverlay } from '@dnd-kit/core'
import { FC } from 'react'
import {
  RailcarPlanningContainer,
  RailcarPlanningContainerProps,
} from '../Molecules/RailcarPlanningContainer'

type Props = {
  container?: RailcarPlanningContainerProps
}

export const RailcarPlanningDragOverlay: FC<Props> = ({ container }) => {
  return (
    <DragOverlay style={{ cursor: 'grabbing' }} zIndex={1000}>
      {container ? <RailcarPlanningContainer {...container} /> : null}
    </DragOverlay>
  )
}
